import React from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import NestedMenu from "./NestedMenu";
import UserAvatar from "../components/UserAvatar";
import { Card, CardBody, Dropdown } from "react-bootstrap";
import { ILayout } from "../interfaces/shared/ILayout";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useTranslation } from "react-i18next";
import { getHomePath } from "../functions/userRoles";

interface IProps {
  routes?: ILayout[] | undefined;
  themeMode?: string;
}
const Sidebar = ({ themeMode, routes }: IProps) => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);
  const unviewedCount = useSelector(
    (state: RootState) => state.incidentAlerts.unviewedCount,
  );
  // New-incident count sits on the page the user is sent to on an alert
  const homePath = getHomePath(userData);
  const homeBadge = unviewedCount > 0 ? String(unviewedCount) : undefined;

  const mapRoutesToMenuItems = (routes: ILayout[]) => {
    return routes
      .filter((route) => route.showInSidebar)
      .map((route) => ({
        id: route.path,
        label: route.title ? t(route.title) : "",
        icon: route?.icon || "ph-duotone ph-house-line",
        link: route.path,
        dataPage: `w_${route.category.toLowerCase()}`,
        badge: route.path === homePath ? homeBadge : undefined,
      }));
  };
  const menuItems = mapRoutesToMenuItems(routes ?? []);

  console.log('Sidebar - Current User Data:', userData);
  console.log('Sidebar - Profile Image URL:', userData?.profileImageUrl);

  return (
    <React.Fragment>
      <nav className="pc-sidebar" id="pc-sidebar-hide">
        <div className="navbar-wrapper">
          <div className="m-header">
            <Link to="/" className="b-brand text-primary">
              {themeMode === "dark" ? (
                <img
                  src={"/assets/images/logo-white.svg"}
                  alt="logo"
                  className="logo-lg landing-logo"
                />
              ) : (
                <img
                  src={"/assets/images/logo-horizontal.png"}
                  alt="logo"
                  className="logo-lg landing-logo w-100"
                />
              )}
            </Link>
          </div>

          <SimpleBar className="navbar-content" style={{ maxHeight: "100vh" }}>
            <ul className="pc-navbar" id="pc-navbar">
              <NestedMenu menuItems={menuItems} />
            </ul>
            {/* <Card className="nav-action-card bg-brand-color-4">
              <CardBody
                style={{
                  backgroundImage: `url(/assets/images/layout/nav-card-bg.svg)`,
                }}
              >
                <h5 className="text-dark">{t("sidebar.helpCenter")}</h5>
                <p className="text-dark text-opacity-75">
                  {t("sidebar.helpCenterDescription")}
                </p>
                <Link
                  to="https://phoenixcoded.support-hub.io/"
                  className="btn btn-primary"
                  target="_blank"
                >
                  {t("sidebar.goToHelpCenter")}
                </Link>
              </CardBody>
            </Card> */}
          </SimpleBar>
          <Card className="pc-user-card">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <UserAvatar imageUrl={userData?.profileImageUrl} size={45} className="user-avtar wid-45" />
                </div>
                <div className="flex-grow-1 ms-3">
                  <Link
                    to="#"
                    className="arrow-none dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-offset="0,20"
                  ></Link>
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h6 className="mb-0">
                        {userData?.firstName} {userData?.lastName}
                      </h6>
                      <small>{userData?.institutionName}</small>
                    </div>

                    {/* <Dropdown>
                      <Dropdown.Toggle
                        variant="a"
                        className="btn btn-icon btn-link-secondary avtar arrow-none"
                        data-bs-offset="0,20"
                      >
                        <i className="ph-duotone ph-windows-logo"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <ul>
                          <li>
                            <Dropdown.Item className="pc-user-links">
                              <i className="ph-duotone ph-user"></i>
                              <span>{t("sidebar.myAccount")}</span>
                            </Dropdown.Item>
                          </li>
                          <li>
                            <Dropdown.Item className="pc-user-links">
                              <i className="ph-duotone ph-gear"></i>
                              <span>{t("sidebar.settings")}</span>
                            </Dropdown.Item>
                          </li>
                          <li>
                            <Dropdown.Item className="pc-user-links">
                              <i className="ph-duotone ph-lock-key"></i>
                              <span>{t("sidebar.lockScreen")}</span>
                            </Dropdown.Item>
                          </li>
                          <li>
                            <Dropdown.Item className="pc-user-links">
                              <i className="ph-duotone ph-power"></i>
                              <span>{t("sidebar.logout")}</span>
                            </Dropdown.Item>
                          </li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown> */}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Sidebar;
